import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-xl border-b border-red-500/30">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-gradient-to-br from-red-500 via-orange-500 to-yellow-500 rounded-full flex items-center justify-center shadow-xl shadow-red-500/50 border-2 border-red-400/50">
              <i className="ri-megaphone-line text-2xl text-white"></i>
            </div>
            <div>
              <h1 className="text-3xl font-black text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                Office <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">WoW</span>
              </h1>
              <p className="text-xs text-red-400 font-semibold tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>Creative Agency</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-8">
            <a href="#about" className="text-gray-300 hover:text-red-400 transition-colors font-semibold text-sm tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              ABOUT
            </a>
            <a href="#services" className="text-gray-300 hover:text-red-400 transition-colors font-semibold text-sm tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              SERVICES
            </a>
            <a href="#portfolio" className="text-gray-300 hover:text-red-400 transition-colors font-semibold text-sm tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              PORTFOLIO
            </a>
            <a href="#contact" className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-6 py-3 rounded-full hover:shadow-xl hover:shadow-red-500/50 transition-all font-bold text-sm tracking-wide whitespace-nowrap" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              CONTACT
            </a>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-red-400 w-10 h-10 flex items-center justify-center"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-red-500/30">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-4">
            <a href="#about" className="text-gray-300 hover:text-red-400 transition-colors py-2 font-semibold" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              ABOUT
            </a>
            <a href="#services" className="text-gray-300 hover:text-red-400 transition-colors py-2 font-semibold" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              SERVICES
            </a>
            <a href="#portfolio" className="text-gray-300 hover:text-red-400 transition-colors py-2 font-semibold" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              PORTFOLIO
            </a>
            <a href="#contact" className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-6 py-3 rounded-full text-center font-bold whitespace-nowrap" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              CONTACT
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}